module.exports = "pegasus/assets/email1-column-3.png";